import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface MswLookupToolState {
}

export default {
  state : {},
  actions: {
    fetchIssueListLookup(context: ActionContext<MswLookupToolState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const url = 'product/issuelistlookup';
      return ApiServiceWrapper.post(url, payload);
    },
  },
  namespaced: true,
} as Module<MswLookupToolState, RootStoreState>;
